import React from 'react';
import { useSelector } from 'react-redux';

export default function useDisburseSelector() {
  const DisburseViewData =
    useSelector((state) => state.Disburse.view_data?.disbursedApplication) || {}; // view data
  const DisburseListData =
    useSelector((state) => state.Disburse.list_data?.disbursedApplications?.content) || []; // List data
  const DisburseDecisionInfo =
    useSelector((state) => state.Disburse.decision_info?.decisions) || {}; // Decision Info data
  return { DisburseViewData, DisburseListData, DisburseDecisionInfo };
}
